<template>
    <div>
        <div class="row">
            <div class="col-xs-12 col-md mb-5 mb-md-0">
                <h2 class="m-0">{{ $t("view.demands.create_demand_button") }}</h2>
            </div>
            <div class="col-xs-12 col-md text-left text-md-right">
                <el-button
                    :disabled="saving"
                    round
                    icon="el-icon-back"
                    size="small"
                    @click="$router.push({name: 'demands'})"
                >
                    {{ $t("common.back") }}
                </el-button>
                <el-button
                    :disabled="saving"
                    type="primary"
                    round
                    size="small"
                    icon="el-icon-s-claim"
                    @click="submitForm"
                >
                    {{ $t("common.save") }}
                </el-button>
            </div>
        </div>

        <el-divider />

        <el-form
            ref="newDemandForm"
            :disabled="saving"
            :model="form"
            :rules="rules"
            label-position="top"
        >
            <div class="row mt-7">
                <div class="col-xs-12 col-md-6 col-xs-offset-0 col-md-offset-3 mb-7">
                    <el-alert
                        v-if="formHasErrors"
                        :title="$t('common.general_error_title')"
                        :description="$t('common.general_error_description')"
                        type="error"
                        effect="dark"
                        show-icon
                    />
                </div>
            </div>

            <div class="row mt-7">
                <div class="col-xs-12 col-md-6 col-xs-offset-0 col-md-offset-3 mb-7">
                    <el-form-item
                        :label="$t('view.demands.demand_field_title')"
                        prop="title"
                    >
                        <el-input
                            v-model="form.title"
                            :placeholder="$t('view.demands.demand_field_title_placeholder')"
                            maxlength="50"
                            show-word-limit
                            class="demand-title"
                        />
                    </el-form-item>
                </div>
            </div>

            <div class="row mt-5">
                <div class="col-xs-12 col-md-6 col-xs-offset-0 col-md-offset-3 mb-7">
                    <el-form-item
                        :label="$t('view.demands.demand_field_notification_body')"
                        :required="true"
                        prop="notification_body"
                    >
                        <el-input
                            v-model="form.notification_body"
                            type="textarea"
                            :placeholder="$t('view.demands.demand_field_notification_body_placeholder')"
                            :autosize="{minRows:2, maxRows:4}"
                            maxlength="150"
                            show-word-limit
                        />
                    </el-form-item>
                </div>
            </div>

            <div class="row mt-5">
                <div class="col-xs-12 col-md-6 col-xs-offset-0 col-md-offset-3 mb-7">
                    <el-form-item
                        :label="$t('view.demands.demand_field_description')"
                        :required="true"
                        prop="description"
                    >
                        <el-input
                            v-model="form.description"
                            type="textarea"
                            :placeholder="$t('view.demands.demand_field_description_placeholder')"
                            :autosize="{minRows: 3, maxRows:10}"
                        />
                    </el-form-item>
                </div>
            </div>

        </el-form>
    </div>
</template>

<script>
import {mapActions, mapState} from "vuex";

export default {
    name: "Demand",
    head() {
        return {
            title: {
                inner: this.$t("view.demands.demands_page_title")
            }
        };
    },
    data    : () => (
        {
            formHasErrors: "",
            form         : {
                title            : "",
                notification_body: "",
                description      : ""
            }
        }
    ),
    computed: {
        ...mapState(
            "demands",
            [
                "saving"
            ]
        ),
        rules() {
            return {
                title            : [
                    {
                        required: true,
                        message : this.$t("view.demands.validation_title_required"),
                        trigger : "blur"
                    }
                ],
                notification_body: [
                    {
                        required: true,
                        message : this.$t("view.demands.validation_title_required"),
                        trigger : "blur"
                    }
                ],
                description      : [
                    {
                        required: true,
                        message : this.$t("view.demands.validation_description_required"),
                        trigger : "blur"
                    }
                ]
            };
        }
    },
    async mounted() {
        if (this.$route.name === "demands_edit" && this.$route.params.id !== "") {
            try {
                const demand = await this.getDemand(this.$route.params.id);

                const title = document.title.split(' | ');
                title[0] = demand.title;
                document.title = title.join(' | ');

                this.form = demand;
            } catch (e) {
                // eslint-disable-next-line no-console
                console.error(e.message);
            }
        }
    },
    methods: {
        ...mapActions(
            "demands",
            [
                "createDemand",
                "updateDemand",
                "getDemand"
            ]
        ),
        submitForm() {
            this.formHasErrors = false;

            this.$refs.newDemandForm.validate(
                async valid => {
                    if (valid) {
                        if (this.$route.name === "demands_edit" && this.$route.params.id !== "") {
                            try {
                                await this.updateDemand(JSON.parse(JSON.stringify(this.form)));
                                this.$refs.newDemandForm.resetFields();
                                this.$router.push(
                                    {
                                        name  : "demands_chat",
                                        params: {
                                            id: this.$route.params.id
                                        }
                                    }
                                );
                                return true;
                            } catch (e) {
                                // eslint-disable-next-line no-console
                                console.error(e.message);
                                this.formHasErrors = true;
                                return false;
                            }
                        } else {
                            try {
                                const demand = await this.createDemand(JSON.parse(JSON.stringify(this.form)));

                                this.$refs.newDemandForm.resetFields();
                                this.$router.push(
                                    {
                                        name  : "demands_chat",
                                        params: {
                                            id: demand.id
                                        }
                                    }
                                );
                                return true;
                            } catch (e) {
                                // eslint-disable-next-line no-console
                                console.error(e.message);
                                this.formHasErrors = true;
                                return false;
                            }
                        }
                    }

                    this.formHasErrors = true;
                    return false;
                }
            );
        }
    }
};
</script>